/**
 * Coerce an unknown value to an array. Non-arrays (including nullish objects
 * mistakenly treated as lists) become [].
 *
 * @param value - Candidate list value from API / Sanity / SWR
 * @returns The original array, or []
 */
export function toArray<T>(value: readonly T[] | null | undefined): T[];
export function toArray<T>(value: unknown): T[];
export function toArray<T>(value: unknown): T[] {
	return Array.isArray(value) ? (value as T[]) : [];
}
